/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var colorsArray = require('../data/colors'),
    gettext     = require('mag-gettext').gettext;

function setValue ( val ) {
    top.gSTB.SetSubtitlesColor(+val); //eslint-disable-line
}

module.exports = function ( app ) {
    return {
        id: 'subtitleColor',
        name: gettext('Subtitle color'),
        description: gettext('Setting the subtitle colour'),
        icon: 'theme-icon-color',
        data: {
            subtitlesColor: 0xFFFFFF
        },
        saveImmediate: true,
        prepareForRender: function ( currentValue, callback ) {
            colorsArray.forEach(function ( item ) {
                item.selected = item.value === currentValue.subtitlesColor;
            });

            callback(colorsArray);
        },
        prepareForSave: function ( value, callback ) {
            this.data.subtitlesColor = value;

            setValue(value);
            callback();
        },
        render: app.api.renders.popupSelect,
        parent: 'playback'
    };
};

module.exports.setValue = setValue;
